var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import DefaultInfoCard from "../../components/InfoCards/DefaultInfoCard";
import { CarouselCard } from "../../components/InfoCards/CarouselCard";
import { BannerInfoCard } from "../../components/InfoCards/BannerInfoCard";
import { contentfulToImageData, formatRichText, formatCTAS, filterConfigs, getContentBlockStyling, } from "../../functions";
import { IconInfoCard } from "../../components/InfoCards/IconInfoCard";
import { BorderlessInfoCard } from "../../components/InfoCards/BorderlessInfoCard";
import { LongCard } from "../../components/InfoCards/LongCard";
import { INFO_CARD_VARIANTS, CONFIGURATION_TYPE_IDS } from "../../constants";
import { CarouselCardVariant } from "../../components/InfoCards/CarouselCardVariant";
import { BannerInfoCardVariant } from "../../components/InfoCards/BannerInfoCardVariant";
import { ConfigurableCarouselCard } from "../../components/InfoCards/ConfigurableCarouselCard";
import { ModalInfoCard } from "./ModalInfoCard";
const CARD_COMPONENT_MAP = {
    [INFO_CARD_VARIANTS.DEFAULT]: DefaultInfoCard,
    [INFO_CARD_VARIANTS.CAROUSEL_CARD]: CarouselCard,
    [INFO_CARD_VARIANTS.CAROUSEL_CARD_VARIANT]: CarouselCardVariant,
    [INFO_CARD_VARIANTS.ICON_INFO_CARD]: IconInfoCard,
    [INFO_CARD_VARIANTS.BORDERLESS_INFO_CARD]: BorderlessInfoCard,
    [INFO_CARD_VARIANTS.HORIZONTAL_INFO_CARD]: LongCard,
    [INFO_CARD_VARIANTS.PILL_IMAGE_INFO_CARD]: DefaultInfoCard,
    [INFO_CARD_VARIANTS.BANNER_CARD]: BannerInfoCard,
    [INFO_CARD_VARIANTS.BANNER_CARD_VARIANT]: BannerInfoCardVariant,
    [INFO_CARD_VARIANTS.MODAL_INFO_CARD]: ModalInfoCard,
    [INFO_CARD_VARIANTS.CONFIGURABLE_CAROUSEL_CARD]: ConfigurableCarouselCard,
};
export const InfoCardWrapper = ({ infoCardSchema, formattedSectionStyles, configurations = [], siteStatus, }) => {
    const infoCardConfig = filterConfigs(configurations, CONFIGURATION_TYPE_IDS.INFO_CARD);
    const { ctas, cardFooter, variant, cardType, cardStyles } = infoCardSchema, rest = __rest(infoCardSchema, ["ctas", "cardFooter", "variant", "cardType", "cardStyles"]);
    const cardSectionStyling = Object.assign(Object.assign({}, formattedSectionStyles), { cardStyling: Object.assign({}, getContentBlockStyling(cardStyles, variant)) });
    const CardComponent = CARD_COMPONENT_MAP[cardType] || DefaultInfoCard;
    const formattedContent = formatRichText(infoCardSchema.content, siteStatus);
    const imageData = contentfulToImageData(infoCardSchema.image);
    const formattedCtas = formatCTAS(ctas, siteStatus);
    const formattedFooter = formatRichText(cardFooter, siteStatus);
    const isEven = false; // cardVariant === INFO_CARD_VARIANTS.BANNER_CARD_VARIANT && index % 2 === 0;
    return (_jsx(CardComponent, Object.assign({}, rest, { content: formattedContent, imageUrl: imageData === null || imageData === void 0 ? void 0 : imageData.imageUrl, imageAlt: imageData === null || imageData === void 0 ? void 0 : imageData.alt, ctas: formattedCtas, cardStyling: cardSectionStyling, footer: formattedFooter, isEven: isEven, infoCardConfig: infoCardConfig !== null && infoCardConfig !== void 0 ? infoCardConfig : {} })));
};
